import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import * as Sentry from "@sentry/react";

const initialState = {
  marketPlace: "None",
};

const marketplaceSlice = createSlice({
  name: "marketPlace",
  initialState,
  reducers: {
    setMarketPlace: (state, action: PayloadAction<string>) => {
      state.marketPlace = action.payload;
      Sentry.setTag("marketPlace", action.payload);
    },
  },
});

export const { setMarketPlace } = marketplaceSlice.actions;
export default marketplaceSlice.reducer;
